import React from 'react';
import { CustomModal, DataList } from 'commons-ui';
import useDashboardActions from 'pages/dashboard/useDashboardActions';
import { LIST_ENTITY_NAMES } from 'constant';
import useService from '../../../useService';
import { makeActionHandler } from '../../actions/handlers';
import { makeActionList } from '../../actions/list';
import { AthenaCrudRequestListConfig, DEFAULT_CONFIG } from './listConfig';

const AthenaCrudRequestList: React.FC<{}> = () => {
	const { getActionHandler, getActionList } = useDashboardActions(makeActionHandler, makeActionList);
	const actions = getActionList();

	const { getAthenaCrudRequests } = useService();
	return (
		<div>
			<CustomModal />
			<DataList
				fetchData={getAthenaCrudRequests}
				columnConfigs={AthenaCrudRequestListConfig()}
				getActionHandler={getActionHandler}
				actions={actions}
				defaults={DEFAULT_CONFIG}
				disablePagination={false}
				disablePaginationSelect={false}
				entity={LIST_ENTITY_NAMES.ATHENA_CRUDS}
				initialSortDirection='DESC'
				initialSortIndex={1}
				filterable={false}
			/>
		</div>
	);
};

export default AthenaCrudRequestList;
